__turbopack_context__.v({
  "tabHeader": "TabHeader-module__dxHBqG__tabHeader",
  "tabHeaderIcon": "TabHeader-module__dxHBqG__tabHeaderIcon",
  "tabHeaderParent": "TabHeader-module__dxHBqG__tabHeaderParent",
  "tabHeaderTitle": "TabHeader-module__dxHBqG__tabHeaderTitle",
  "tabHeaderTitles": "TabHeader-module__dxHBqG__tabHeaderTitles",
});
